module.exports = __webpack_public_path__ + "img/docx.4b3270a4.svg";